/** Helpers for GET /messages/suggestion/{id} — suggestions_by_tone only, no client fallbacks. */

export function normalizeApiFlag(value) {
  if (value === true || value === 1) return true
  if (typeof value === "string") {
    const v = value.trim().toLowerCase()
    return v === "true" || v === "1" || v === "yes"
  }
  return false
}

export function normalizeSuggestionToneKey(tone) {
  const t = String(tone || "neutral").trim().toLowerCase()
  if (t === "formal" || t === "casual" || t === "neutral") return t
  return "neutral"
}

export function normalizeSuggestionsByTone(raw) {
  const empty = { formal: [], neutral: [], casual: [] }
  if (!raw || typeof raw !== "object") return empty

  const out = { formal: [], neutral: [], casual: [] }
  for (const [key, list] of Object.entries(raw)) {
    const toneKey = normalizeSuggestionToneKey(key)
    const arr = Array.isArray(list) ? list : []
    out[toneKey] = arr
      .map((item) => {
        if (typeof item === "string") return { reply_text: item }
        if (item?.reply_text != null && String(item.reply_text).trim() !== "") {
          return { reply_text: String(item.reply_text) }
        }
        if (item?.text != null && String(item.text).trim() !== "") {
          return { reply_text: String(item.text) }
        }
        return null
      })
      .filter(Boolean)
  }
  return out
}

export function suggestionTextsForTone(suggestionsByTone, tone) {
  const key = normalizeSuggestionToneKey(tone)
  const list = suggestionsByTone?.[key] || []
  return list
    .map((item) => (typeof item === "string" ? item : item?.reply_text))
    .filter((text) => text != null && String(text).trim() !== "")
}

export function apiSuggestionsMatchInteraction(suggestionsState, interactionId) {
  if (suggestionsState?.status !== "succeeded") return false
  if (interactionId == null || String(interactionId).trim() === "") return false
  return String(suggestionsState.interactionId ?? "") === String(interactionId)
}
